module.exports = __webpack_public_path__ + "img/disConnect.5deeeb31.svg";